import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import withRouter from "../hooks/withRouter"

import { GitHub } from "../pages/github";

import { Admin } from "../pages/admin";
import { Join } from "../pages/join";
import { CoffeeChat } from "../pages/join/CoffeeChat";
import { ContactTab } from "../pages/join/ContactTab";
import { featureFlags } from "../content_option";

const HIRING_URL = "https://yechxn.notion.site/Rosota-Inc-Robotics-AI-3D-Reconstruction-Researcher-370e1d48d5268021baa2fd2ee818768a";

function HiringRedirect() {
  useEffect(() => {
    window.location.replace(HIRING_URL);
  }, []);
  return null;
}

function StaticPage({ path }) {
  useEffect(() => { window.location.replace(path + window.location.search + window.location.hash); }, [path]);
  return null;
}
const AnimatedRoutes = withRouter(({ location }) => (
  <Routes location={location}>
    <Route exact path="/" element={<StaticPage path="/" />} />
    <Route path="/about" element={<StaticPage path="/about" />} />

    {/* Join us — tabbed */}
    <Route path="/join" element={<Join />}>
      <Route index element={<ContactTab />} />
      {featureFlags.coffeeChat && <Route path="coffee" element={<CoffeeChat />} />}
      <Route path="contact" element={<ContactTab />} />
    </Route>

    {/* Coffee Chat temporarily hidden — send direct/bookmarked links back to Join */}
    {!featureFlags.coffeeChat && <Route path="/join/coffee" element={<Navigate to="/join" replace />} />}

    {/* Newsletter tab removed — keep bookmarked and prerendered links working */}
    <Route path="/join/newsletter" element={<Navigate to="/join" replace />} />

    {/* Backward-compat redirects */}
    <Route path="/contact" element={<Navigate to="/join" replace />} />
    <Route path="/advisor" element={<Navigate to="/" replace />} />
    <Route path="/lecture" element={<Navigate to="/" replace />} />
    <Route path="/lecture/:id" element={<Navigate to="/" replace />} />
    <Route path="/crew/*" element={<Navigate to="/" replace />} />

    <Route path="/github" element={<GitHub />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="/hiring" element={<HiringRedirect />} />
    <Route path="*" element={<StaticPage path="/" />} />
  </Routes>
));

function AppRoutes() {
  return (
    <div className="s_c">
      <AnimatedRoutes />
    </div>
  );
}

export default AppRoutes;
